(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom_image-gallery"] && !Shopify.designMode) return;
  try {
    /**
 * Animated Image Columns - Minimal JavaScript Enhancement
 * 
 * This script provides only essential functionality that CSS cannot handle:
 * - Intersection Observer for performance (pausing offscreen animations)
 * - Dynamic reduced motion preference changes
 * 
 * All animations are CSS-driven for optimal performance.
 */

class AnimatedImageColumns {
  constructor(element) {
    this.element = element;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Only initialize if animations are enabled and motion is not reduced
    if (!this.element.classList.contains('animated-image-columns--no-animations') && !this.prefersReducedMotion) {
      this.init();
    }
  }

  init() {
    this.setupIntersectionObserver();
    this.listenForMotionPreferenceChanges();
  }

  /**
   * Pause animations when not visible for performance
   */
  setupIntersectionObserver() {
    if (!('IntersectionObserver' in window)) return;

    // Check if this is an always-animate mode - these need intersection observer
    const isAlwaysAnimate = this.element.classList.contains('animated-image-columns--always-animate');
    
    // Only use intersection observer for always-animate mode or mobile
    if (!isAlwaysAnimate && window.matchMedia('(hover: hover)').matches) {
      return; // Hover mode doesn't need intersection observer on desktop
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const scrollTracks = entry.target.querySelectorAll('.animated-image-columns__scroll-track');
        
        scrollTracks.forEach(track => {
          if (entry.isIntersecting) {
            // Only resume if not in hover mode, or if always-animate mode
            if (isAlwaysAnimate || !window.matchMedia('(hover: hover)').matches) {
              track.style.animationPlayState = 'running';
            }
          } else {
            track.style.animationPlayState = 'paused';
          }
        });
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    this.observer.observe(this.element);
  }

  /**
   * Listen for changes in motion preference
   */
  listenForMotionPreferenceChanges() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        this.element.classList.add('animated-image-columns--reduced-motion');
        this.cleanup();
      } else {
        this.element.classList.remove('animated-image-columns--reduced-motion');
        if (!this.element.classList.contains('animated-image-columns--no-animations')) {
          this.init();
        }
      }
    });
  }

  /**
   * Clean up resources
   */
  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

/**
 * Initialize components efficiently
 */
function initializeImageColumns() {
  const imageColumns = document.querySelectorAll('.animated-image-columns:not([data-initialized])');
  
  imageColumns.forEach((element, index) => {
    element.setAttribute('data-initialized', 'true');
    new AnimatedImageColumns(element);
  });
}

// Initialize on DOM ready with multiple fallbacks
function safeInit() {
  try {
    initializeImageColumns();
  } catch (error) {
    // Fail silently in production
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeInit);
} else {
  safeInit();
}

// Additional fallback - try again after a short delay
setTimeout(safeInit, 100);

// Handle dynamically added content (theme editor)
const observer = new MutationObserver((mutations) => {
  let shouldInit = false;
  
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList?.contains('animated-image-columns') && !node.hasAttribute('data-initialized')) {
          shouldInit = true;
        } else if (node.querySelectorAll) {
          const newColumns = node.querySelectorAll('.animated-image-columns:not([data-initialized])');
          if (newColumns.length > 0) {
            shouldInit = true;
          }
        }
      }
    });
  });
  
  if (shouldInit) {
    // Debounce initialization to avoid excessive calls
    clearTimeout(observer.initTimeout);
    observer.initTimeout = setTimeout(initializeImageColumns, 100);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom_training_announcements_calendar_block"] && !Shopify.designMode) return;
  try {
    class EventCalendar {
  constructor() {
    const dataElement = document.getElementById('articleData');
    if (!dataElement) {
      console.error('Article data not found');
      return;
    }
    
    this.data = JSON.parse(dataElement.textContent);
    this.currentMonth = this.data.defaultMonth;
    this.currentDate = this.data.currentDate;
    this.availableMonths = this.data.availableMonths || [];
    this.articles = this.data.articles || [];
    
    console.log('🗓️ Calendar Debug Info:', this.data.debugInfo);
    console.log('📅 Available months:', this.availableMonths);
    console.log('📝 Articles with events:', this.articles.map(a => ({
      title: a.title,
      date: a.event_date,
      month: a.event_month
    })));
    console.log('🎯 Default month:', this.currentMonth);
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.renderCalendar();
    this.updateNavigationButtons();
  }
  
  bindEvents() {
    const monthSelect = document.getElementById('monthSelect');
    const prevBtn = document.getElementById('prevMonth');
    const nextBtn = document.getElementById('nextMonth');
    const calendarGrid = document.getElementById('calendarGrid');
    
    if (monthSelect) {
      monthSelect.addEventListener('change', (e) => {
        const newMonth = e.target.value;
        console.log('📅 Month dropdown changed:', {
          from: this.currentMonth,
          to: newMonth,
          isValidMonth: this.availableMonths.includes(newMonth)
        });
        
        if (this.availableMonths.includes(newMonth)) {
          this.currentMonth = newMonth;
          this.renderCalendar();
          this.updateNavigationButtons();
        } else {
          console.error('❌ Invalid month selected:', newMonth);
        }
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        console.log('Previous month clicked');
        this.navigateMonth(-1);
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        console.log('Next month clicked');
        this.navigateMonth(1);
      });
    }
    
    // Use event delegation for calendar day clicks
    if (calendarGrid) {
      calendarGrid.addEventListener('click', (e) => {
        const dayElement = e.target.closest('.calendar-day');
        if (dayElement && !dayElement.classList.contains('empty-day')) {
          const date = dayElement.dataset.date;
          if (date) {
            // Check if clicking on "more events" button
            if (e.target.classList.contains('more-events')) {
              e.preventDefault();
              e.stopPropagation();
              this.showDayEvents(date);
            } 
            // Check if clicking on event link
            else if (!e.target.closest('.event-item')) {
              this.handleDayClick(date);
            }
          }
        }
      });
    }
  }
  
  navigateMonth(direction) {
    const currentIndex = this.availableMonths.indexOf(this.currentMonth);
    const newIndex = currentIndex + direction;
    
    console.log('🔄 Navigation attempt:', { 
      currentMonth: this.currentMonth,
      currentIndex, 
      newIndex, 
      direction,
      availableMonths: this.availableMonths,
      canNavigate: newIndex >= 0 && newIndex < this.availableMonths.length
    });
    
    if (newIndex >= 0 && newIndex < this.availableMonths.length) {
      this.currentMonth = this.availableMonths[newIndex];
      
      console.log('✅ Navigated to:', this.currentMonth);
      
      // Update the dropdown
      const monthSelect = document.getElementById('monthSelect');
      if (monthSelect) {
        monthSelect.value = this.currentMonth;
        console.log('📝 Dropdown updated to:', monthSelect.value);
      }
      
      this.renderCalendar();
      this.updateNavigationButtons();
    } else {
      console.log('❌ Navigation blocked - index out of bounds');
    }
  }
  
  updateNavigationButtons() {
    const currentIndex = this.availableMonths.indexOf(this.currentMonth);
    const prevBtn = document.getElementById('prevMonth');
    const nextBtn = document.getElementById('nextMonth');
    
    const prevDisabled = currentIndex <= 0;
    const nextDisabled = currentIndex >= this.availableMonths.length - 1;
    
    if (prevBtn) {
      prevBtn.disabled = prevDisabled;
      prevBtn.style.opacity = prevDisabled ? '0.4' : '1';
    }
    
    if (nextBtn) {
      nextBtn.disabled = nextDisabled;
      nextBtn.style.opacity = nextDisabled ? '0.4' : '1';
    }
    
    console.log('🎮 Navigation buttons updated:', {
      currentMonth: this.currentMonth,
      currentIndex,
      totalMonths: this.availableMonths.length,
      prevDisabled,
      nextDisabled,
      canGoPrev: !prevDisabled,
      canGoNext: !nextDisabled
    });
  }
  
  getArticlesForMonth(yearMonth) {
    if (!yearMonth) return [];
    const filtered = this.articles.filter(article => 
      article.event_date && article.event_date.startsWith(yearMonth)
    );
    console.log(`Articles for ${yearMonth}:`, filtered.length);
    return filtered;
  }
  
  getArticlesForDate(date) {
    if (!date) return [];
    return this.articles.filter(article => article.event_date === date);
  }
  
  renderCalendar() {
    console.log('Rendering calendar for month:', this.currentMonth);
    
    if (!this.currentMonth) {
      console.error('No current month set');
      return;
    }
    
    const [year, month] = this.currentMonth.split('-');
    const monthArticles = this.getArticlesForMonth(this.currentMonth);
    
    // Update event count
    const eventCountEl = document.getElementById('eventCount');
    if (eventCountEl) {
      eventCountEl.textContent = `${monthArticles.length} event${monthArticles.length !== 1 ? 's' : ''}`;
    }
    
    // Calculate calendar data
    const firstDay = new Date(parseInt(year), parseInt(month) - 1, 1);
    const lastDay = new Date(parseInt(year), parseInt(month), 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    
    console.log('Calendar data:', {
      year: parseInt(year),
      month: parseInt(month),
      daysInMonth,
      startingDayOfWeek,
      monthArticles: monthArticles.length
    });
    
    // Generate calendar HTML
    let calendarHTML = '';
    
    // Day headers
    const dayHeaders = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    dayHeaders.forEach(day => {
      calendarHTML += `<div class="day-header">${day}</div>`;
    });
    
    // Empty cells for days before month starts
    for (let i = 0; i < startingDayOfWeek; i++) {
      calendarHTML += '<div class="calendar-day empty-day"></div>';
    }
    
    // Calendar days
    for (let day = 1; day <= daysInMonth; day++) {
      const date = `${year}-${month.padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      const dayArticles = this.getArticlesForDate(date);
      const isToday = date === this.currentDate;
      
      let dayClasses = 'calendar-day';
      if (dayArticles.length > 0) dayClasses += ' has-events';
      if (isToday) dayClasses += ' today';
      
      let eventsHTML = '';
      if (dayArticles.length > 0) {
        const displayLimit = 2;
        const displayArticles = dayArticles.slice(0, displayLimit);
        
        eventsHTML = '<div class="day-events">';
        displayArticles.forEach(article => {
          eventsHTML += `
            <a href="${article.url}" class="event-item">
              <h4 class="event-title">${this.truncateText(article.title, 25)}</h4>
              <span class="event-time">${article.event_time}</span>
            </a>
          `;
        });
        
        if (dayArticles.length > displayLimit) {
          eventsHTML += `
            <div class="more-events">
              +${dayArticles.length - displayLimit} more
            </div>
          `;
        }
        eventsHTML += '</div>';
        
        if (dayArticles.length > 0) {
          eventsHTML += `<div class="event-count-indicator">${dayArticles.length}</div>`;
        }
      }
      
      const dateObj = new Date(date + 'T00:00:00');
      const monthName = dateObj.toLocaleDateString('en-US', { month: 'short' });
      const dayOfWeekName = dateObj.toLocaleDateString('en-US', { weekday: 'short' });

      calendarHTML += `
        <div class="${dayClasses}" data-date="${date}">
          <div class="day-number">
            <span class="day-date-extra month-name">${monthName}</span>
            <span class="day-date-extra day-of-week">${dayOfWeekName}</span>
            <span class="day-num-val">${day}</span>
          </div>
          ${eventsHTML}
        </div>
      `;
    }
    
    const calendarGrid = document.getElementById('calendarGrid');
    if (calendarGrid) {
      calendarGrid.innerHTML = calendarHTML;
      console.log('Calendar HTML updated');
    } else {
      console.error('Calendar grid element not found');
    }
  }
  
  handleDayClick(date) {
    const articles = this.getArticlesForDate(date);
    console.log(`Day ${date} clicked, ${articles.length} articles found`);
    if (articles.length > 2) {
      this.showDayEvents(date);
    }
  }
  
  showDayEvents(date) {
    const articles = this.getArticlesForDate(date);
    if (articles.length === 0) return;
    
    const modal = document.getElementById('eventModal');
    const modalDate = document.getElementById('modalDate');
    const modalEvents = document.getElementById('modalEvents');
    
    if (!modal || !modalDate || !modalEvents) {
      console.error('Modal elements not found');
      return;
    }
    
    // Format date for display
    const dateObj = new Date(date + 'T00:00:00');
    const formattedDate = dateObj.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    
    modalDate.textContent = formattedDate;
    
    let eventsHTML = '';
    articles.forEach(article => {
      eventsHTML += `
        <div class="modal-event-item">
          <div class="modal-event-title">${article.title}</div>
          <div class="modal-event-time">${article.event_time}</div>
          <a href="${article.url}" class="modal-event-link">View Event</a>
        </div>
      `;
    });
    
    modalEvents.innerHTML = eventsHTML;
    modal.style.display = 'flex';
  }
  
  truncateText(text, length) {
    return text.length > length ? text.substring(0, length) + '...' : text;
  }
}

function closeEventModal() {
  const modal = document.getElementById('eventModal');
  if (modal) {
    modal.style.display = 'none';
  }
}

// Initialize calendar when DOM is loaded
let eventCalendar;
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing calendar...');
  try {
    eventCalendar = new EventCalendar();
    // Expose to global scope for debugging
    window.eventCalendar = eventCalendar;
    console.log('Calendar initialized successfully');
  } catch (error) {
    console.error('Failed to initialize calendar:', error);
  }
});

// Close modal when clicking outside or on overlay
document.addEventListener('click', function(e) {
  const modal = document.getElementById('eventModal');
  const overlay = e.target.closest('.modal-overlay');
  if (modal && (e.target === modal || overlay)) {
    closeEventModal();
  }
});

// Handle escape key to close modal
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeEventModal();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom_training_announcements_sidebar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const list = document.getElementById('sidebar-eventList');
  if (!list) return;

  const allItems = Array.from(list.querySelectorAll('.sidebar-event-list-item'));
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to the beginning of today for comparison

  // 1. Filter for future events
  const futureItems = allItems.filter(item => {
    const eventDate = new Date(item.dataset.eventDate);
    return eventDate >= today;
  });

  // 2. Check for empty state
  if (futureItems.length === 0) {
    const emptyMessage = document.createElement('div');
    emptyMessage.className = 'sidebar-event-empty-state';
    emptyMessage.innerHTML = '<p>There are no upcoming training announcements at this time. Please check back later.</p>';
    list.parentNode.replaceChild(emptyMessage, list); // Replace the list with the message
    return;
  }

  // 3. Sort the future items
  futureItems.sort((a, b) => {
    const dateA = new Date(a.dataset.eventDate);
    const dateB = new Date(b.dataset.eventDate);
    return dateA - dateB;
  });

  // 3b. Limit to the next 10 upcoming events
  const itemsToShow = futureItems.slice(0, 8);

  // 4. Clear the list and re-append sorted items with month headers
  list.innerHTML = '';
  let currentMonthHeader = '';

  itemsToShow.forEach(item => {
    const eventDate = new Date(item.dataset.eventDate);
    const monthYear = eventDate.toLocaleString('en-US', { month: 'long', year: 'numeric' });

    if (monthYear !== currentMonthHeader) {
      const header = document.createElement('h4');
      header.className = 'sidebar-event-list-month-header';
      header.textContent = monthYear;
      list.appendChild(header);
      currentMonthHeader = monthYear;
    }
    list.appendChild(item);
  });

  // Make the list visible after sorting
  list.style.visibility = 'visible';
});
  } catch(e) { console.error(e); }
})();

})();
